var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8462 1H7V10H21V3.25C21 1.45 19.5641 1 18.8462 1Z",
    fill: "#3C55A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 10.9V17.5C23 21.9 21.9 23 17.5 23H6.5C2.1 23 1 21.9 1 17.5V6.5C1 2.1 2.1 1 6.5 1H8.15C9.8 1 10.163 1.484 10.79 2.32L12.44 4.52C12.858 5.07 13.1 5.4 14.2 5.4H17.5C21.9 5.4 23 6.5 23 10.9Z",
    fill: "#5679EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2993 10.1335L17.1647 11.6874C18.2784 12.1323 18.2784 12.8677 17.1647 13.3126L13.2993 14.8665C12.8603 15.0445 12.1397 15.0445 11.7007 14.8665L7.83532 13.3126C6.72156 12.8677 6.72156 12.1323 7.83532 11.6874L11.7007 10.1335C12.1397 9.95552 12.8603 9.95552 13.2993 10.1335Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15C7 15.4717 7.385 16.0164 7.85556 16.2073L12.005 17.9031C12.3228 18.0323 12.6833 18.0323 12.995 17.9031L17.1444 16.2073C17.615 16.0164 18 15.4717 18 15",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollection);
export default __webpack_public_path__ + "static/media/collection.97a25be1.svg";
export { ForwardRef as ReactComponent };